import React from 'react';
import { observer } from 'mobx-react-lite';
import CustomButton from '../../../shared/custom-button/custom-button';
import './policy-modal.scss';

interface ApplyingPolicyModalContentProps {
    title?: string;
    message?: string;
    onClickGotIt: () => void;
}

export const ApplyingPolicyModalContent: React.FC<ApplyingPolicyModalContentProps> = observer(({
                                                                                                   title,
                                                                                                   message,
                                                                                                   onClickGotIt
                                                                                               }) => {
    return <div className="policy-content">
        <div
            className="policy-title">{title || 'Your policy is being applied'}
        </div>
        <div className="policy-subtitle">
            {message || 'It may take a few minutes until activated. You will be notified.\n' +
            'Once active, you can update this policy anytime from the Policy menu\n' +
            'according to your changing business needs.'}
        </div>
        <div className="policy-footer">
            <CustomButton className="primary-btn btn-close" label="Got it" onClick={onClickGotIt}/>
        </div>
    </div>;
});